import React from "react";

export default function LeftAlignmentIcon(props) {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 6.24 6.24"
      enableBackground="new 0 0 6.24 6.24"
    >
      <path
        fill={props.color}
        d="m0,6.24v-0.479h6.24v0.479h-6.24zm0-1.92v-0.48h4.8v0.48h-4.8zm0-1.92v-0.48h6.24v0.48h-6.24zm0-1.92v-0.48h4.8v0.48h-4.8z"
      />
    </svg>
  );
}
